import { AdminApi, ApiAdminSetNewSubscriptionLevelPostRequest, WebApiAdminDtoCreateUserDto, WebApiAdminDtoInvoiceGenerationRequest, WebApiAdminDtoSetSubscriptionDto, WebApiPaymentRepositoryPingPaymentsDtoTenantUpdateTenantRequest } from "../Repository/eventbookyapi";
import { GetApiConfiguration } from "./ServiceConfiguration";
import { DashboardService } from "./DashboardService";

export abstract class AdminService {
    public static CreateCompany = async (request: WebApiAdminDtoCreateUserDto) => {
        return new AdminApi(GetApiConfiguration()).apiAdminCreateUserPost({
            webApiAdminDtoCreateUserDto: request
        });
    };

    public static GetAllUsers = async () => {
        return new AdminApi(GetApiConfiguration()).apiAdminGetAllUsersGet();
    };

    public static SetUserAsAdmin = async (userId: number, companyId: number) => {
        const requestOptions = {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            credentials: 'include' as RequestCredentials,
            body: JSON.stringify({ userId, companyId })
        };
        const response = await fetch(process.env.REACT_APP_API_URL + '/Admin/SetUserAsAdmin', requestOptions);
        return response.json();
    };

    public static DeleteAllCompanyMembers = async (companyId: number) => {
        return new AdminApi(GetApiConfiguration()).apiAdminDeleteAllMembersDelete({ companyId: companyId });
    };

    public static DeleteAllMemberFields = async (companyId: number) => {
        return new AdminApi(GetApiConfiguration()).apiAdminDeleteAllMemberFieldsDelete({ companyId: companyId });
    };

    public static SetSubscription = async (companyId: number, subscription: WebApiAdminDtoSetSubscriptionDto) => {
        const body: ApiAdminSetNewSubscriptionLevelPostRequest = { webApiAdminDtoSetSubscriptionDto: subscription, companyId: companyId };
        return new AdminApi(GetApiConfiguration()).apiAdminSetNewSubscriptionLevelPost(body);
    };

    public static GetDashboard = async () => {
        return new AdminApi(GetApiConfiguration()).apiAdminDashboardGet();
    };

    public static GetTenant = async () => {
        return new AdminApi(GetApiConfiguration()).apiAdminGetTenantGet();
    };

    public static UpdateTenant = async (request: WebApiPaymentRepositoryPingPaymentsDtoTenantUpdateTenantRequest) => {
        return new AdminApi(GetApiConfiguration()).apiAdminUpdateTenantPut({
            webApiPaymentRepositoryPingPaymentsDtoTenantUpdateTenantRequest: request,
        });
    };

    public static GenerateInvoicePdf = async (request: WebApiAdminDtoInvoiceGenerationRequest): Promise<void> => {
        const response = await new AdminApi(GetApiConfiguration()).apiAdminGenerateInvoicePdfPostRaw({
            webApiAdminDtoInvoiceGenerationRequest: request
        });
        const blob = await response.raw.blob();
        const url = URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = `Faktura_${request.invoiceNumber}.pdf`;
        a.click();
        URL.revokeObjectURL(url);
    };
}